import * as React from "react";

interface ButtonProps {
  children?: any;
  className?: string;
  primary?: boolean;
  onClick: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  dataCy?: string;
  dataTestId?: string;
  tooltip?: string;
  disabledHoverTooltip?: string;
}

export function Button(props: ButtonProps) {
  const [hover, setHover] = React.useState(false);
  return (
    <>
      <button
        className={`btn tw-relative ${
          props.primary !== undefined && "btn-success focus:tw-text-white"
        } ${props.className} ${
          props.disabled && "tw-cursor-not-allowed tw-opacity-50"
        }`}
        onClick={(e) => props.onClick(e)}
        data-cy={props.dataCy !== undefined ? props.dataCy : null}
        data-testid={props.dataTestId}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        disabled={!!props.disabled}
      >
        {hover && props.tooltip !== undefined ? (
          <div>
            <div className="tw-absolute tw-left-[50%] tw-top-[-45px] tw-translate-x-[-50%] tw-rounded-md tw-bg-black tw-p-[8px] tw-text-white">
              {props.tooltip}
            </div>
            <div className="tw-absolute tw-left-[50%] tw-top-[-15px] tw-h-[10px] tw-w-[10px] tw-translate-x-[-50%] tw-rotate-45 tw-bg-black" />
          </div>
        ) : null}
        {props.children}
      </button>
    </>
  );
}

interface WebsiteButtonProps {
  children?: any;
  className?: string;
  primary?: boolean;
  disabled?: boolean;
}

export function WebsiteImageButton(props: WebsiteButtonProps) {
  return (
    <button
      className={`tw-absolute tw-bottom-0 tw-left-0 tw-w-[100%] tw-border-0 tw-border-none tw-bg-blue-1 tw-py-[22px] tw-text-[18px] tw-font-bold tw-text-white`}
      style={{ fontFamily: "'DM Sans', sans-serif" }}
      disabled={!!props.disabled}
    >
      {props.children}
    </button>
  );
}

export function WebsiteButton(props: WebsiteButtonProps) {
  return (
    <button
      className={`tw-rounded-md tw-border-0 tw-bg-blue-1 tw-px-[20px] tw-py-[12px] tw-text-[18px] tw-font-bold tw-text-white 440:tw-mb-[80px] ${props.className}`}
      style={{ fontFamily: "'DM Sans', sans-serif" }}
      disabled={props.disabled && true}
    >
      {props.children}
    </button>
  );
}

export function ProviderNoteButton(props: ButtonProps) {
  return (
    <Button
      className={`tw-mr-[10px] tw-rounded-lg tw-px-[15px] tw-py-[10px] tw-text-[15px] ${props.className}`}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.children}
    </Button>
  );
}
